<script lang="ts">
	import { page } from '$app/stores';
	import Login from '$lib/components/Auth/Login/Login.svelte';
	import { redirectBySearchParams } from '$lib/service/navigation';

	function handleEmailLogIn() {
		redirectBySearchParams($page.url, '/');
	}
</script>

<div class="vert-center">
	<div class="flex-1 flex">
		<div class="flex-1 w-1/2 bg-lemon bg-svg bg-gradient-signup hidden md:block" />
		<Login
			additionalClass="flex-1 w-1/2 vert-center mx-auto px-4 sm:px-8"
			on:success={() => handleEmailLogIn()}
		/>
	</div>
</div>
